<template>
  <Validator label="" :v="v" input>
    <div class="custom-input">
      <div
        :class="{
          'outline-block': true,
          'outline-block--focus': inputFocus,
          'outline-border-error': v.$invalid && v.$dirty || validation
        }">
        <input
          :aria-label="montarLabelAria()"
          :type="type"
          :class="{ 'outline-border-error': (v.$invalid && v.$dirty) || validation, 'outline-input': true }"
          style="min-heigth: 15px; font-size: 14px;"
          :disabled="disabled"
          :readonly="readonly"
          :required="required"
          :placeholder="placeholder"
          :maxlength="maxlength()"
          :max="tratarMax()"
          :min="min"
          :value="value"
          :step="step"
          @input="onInput"
          @change="$emit('change')"
          @click="$emit('click')"
          @focus="onFocus"
          @blur="onBlur"
          @keyup="$emit('keyup')"
          @keydown="$emit('keydown')"
          ref="input"
          @keypress="onKeyPress" />
          <div
            :class="{
              'outline-label' : true,
              'outline-label-up': value || inputFocus || type == 'date' || type == 'time' || type == 'datetime-local' || placeholder,
              'outline--focus': inputFocus,
              'outline-error': v.$invalid && v.$dirty
            }">
            {{ montarLabel() }}
          </div>
          <div class="outline-disabled" style="font-size: 14px;"></div>
          <v-icon class="outline-icon-right">{{ iconRight }}</v-icon>
      </div>
    </div>
  </Validator>
</template>

<script>
import Validator from './Valitador.vue';

export default {
  inheritAttrs: false,
  nome: 'Input',
  components: {
    Validator,
  },
  props: {
    type: String,
    label: {
      type: String,
      default: '',
    },
    placeholder: String,
    iconRight: String ,
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number
    },
    v: {
      type: Object,
      default() {
        return {
          $invalid: false,
          $dirty: false,
          $params: [],
          $touch: () => {},
        };
      },
    },
    step: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      inputFocus: false,
    };
  },
  methods: {
    onInput(event) {
      if (this.maxlength()) { event.target.value = event.target.value.substring(0, this.maxlength()); }
      this.$emit('input', event.target.value);
    },
    onFocus() {
      this.inputFocus = true;
      this.$emit('focus');
    },
    onBlur() {
      this.v.$touch();
      this.inputFocus = false;

      if (this.type == 'date' && this.value == '') { this.$emit('input', ''); }

      this.$emit('blur');
    },
    maxlength() {
      if (typeof this.v.$params.maxLength === 'undefined') { return; }

      return this.v.$params.maxLength.max;
    },
    onKeyPress(event) {
      this.$emit('keypress');
    },
    tratarMax() {
      if (this.type == 'date') { return '2999-12-31'; }
    },
    montarLabel() {
      return `${this.label}${(typeof this.v.$params.required !== 'undefined' && this.v.$params.required != null) ? '*' : ''}`;
    },
    montarLabelAria() {
      let  removeAsterisco = this.montarLabel();
      if (removeAsterisco.endsWith("*"))  {
        removeAsterisco = removeAsterisco.slice(0,-1) + ". Campo Obrigatório ";
      } 
      return removeAsterisco;
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/input.scss';
</style>
